import React from 'react';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { Button, Col, Input, Row } from 'reactstrap';

import americanExpressImg from '../../../assets/img/cards/american-express.png';
import dinersClubImg from '../../../assets/img/cards/diners-club.png';
import discoverImg from '../../../assets/img/cards/discover.png';
import jcbImg from '../../../assets/img/cards/jcb.png';
import mastercardImg from '../../../assets/img/cards/mastercard.png';
import unionPayImg from '../../../assets/img/cards/union-pay.png';
import visaImg from '../../../assets/img/cards/visa.png';
import countryCodes from '../../../assets/js/countryCodes';
import { STRIPE_API_VERSION } from '../../../utils/constants';
import history from '../../../utils/history';
import { getIosToStripeSwitchType } from '../../../utils/subscriptionConstants';
import { AudioMessage } from '../../AudioMessage/AudioMessage';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import ModalBase from '../../ModalBase/ModalBase';
import ElementCard from '../../SignUp/SubscriptionBillingModal/ElementCard';
import { ModalNoReferences } from '../ModalNoReferences';

const style = {
  empty: {
    '::placeholder': {
      color: '#adb5bd',
      fontWeight: '400',
      fontFamily: 'sans-serif',
    },
  },
  base: {
    fontSize: '16px',
    fontWeight: '400',
    color: '#1c3b60',
    fontFamily: 'sans-serif',
  },
};

const initialState = {
  tax: 0,
  firstName: '',
  lastName: '',
  city: '',
  address: '',
  statesList: [],
  cardElementMounted: false,
  expirationElementMounted: false,
  cvcElementMounted: false,
  cardCVC: '',
  cardExpiry: '',
  cardNumber: '',
  stateSelectorIsOpen: false,
  country: { name: 'United States', shortCode: 'US' },
  state: { name: '', shortCode: '' },
  zip: '',
  taxJarReady: false,
  terms: false,
  automaticCall: false,
  mustEditPaymentDetails: false,
  isEditingPaymentDetails: false,
  activationSent: false,
  selectedPlan: { id: '' },
  couponCode: '',
  couponChanged: false,
  planChanged: false,
  error: null,
  card: '',
  tokenCard: '',
  isLoadingTokenCard: false,
  errorMessage: '',
  showModal: false,
  closeButton: false,
  isSubmittingIosToStripe: false,
  openModalNoReferences: false,
};

// This is displayed in Account Settings > Manage My Subscription
// - Edit payment stripe subs
// - Switching to ios option
// - Revert cancellation
class BillingInformation extends React.Component {
  getStripe = () =>
    window.Stripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
      locale: 'en',
      apiVersion: STRIPE_API_VERSION,
    });

  constructor(props) {
    super(props);
    this.state = initialState;
    this.cardElement = null;

    if (window.Stripe) {
      this.stripe = this.getStripe();
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        this.stripe = this.getStripe();
      });
    }
  }

  handleCardReady = (element) => {
    this.cardElement = element;
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (nextProps.subscriptionOperationMessage?.type === 'error' &&
        !nextProps.subscriptionOperationWaiting) ||
      (this.props.editPaymentDetailsMessage !==
        nextProps.editPaymentDetailsMessage &&
        nextProps.editPaymentDetailsMessage?.type === 'error')
    ) {
      // Clean using Stripe API
      if (this.cardElement) {
        this.cardElement.clear();
      }
      this.setState({
        isSubmittingIosToStripe: false,
        tokenCard: '',
        zip: '',
      });
    }

    if (nextProps.editPaymentDetailsSuccess) {
      this.props.setEditPaymentDetailsSuccess(false);
      this.enableChangePaymentDetails(false);
    }

    if (nextProps.subscriptionOperationSuccess) {
      this.props.setSubscriptionOperationSuccess(false);
    }

    if (nextProps.revertCancellationMessage?.text) {
      setTimeout(() => {
        this.props.setRevertCancellationMessage({ type: 'success', text: '' });
      }, 4000);
    }

    if (nextProps.subscriptionOperationSuccess) {
      this.props.setSubscriptionOperationSuccess(false);
    }
    if (nextProps.coupon && this.state.planChanged) {
      this.setState({ planChanged: false, couponChanged: false });
    }
  }

  hideMessage = (functionParam) => {
    functionParam({ type: 'success', text: '' });
  };

  enableChangePaymentDetails = (value) => {
    this.setState(initialState);
    this.setState({ isEditingPaymentDetails: value });
    if (!value) {
      const userSubscription = this.props.userSubscription;
      if (!userSubscription?.card?.address_country) return;

      this.setState({
        country: {
          name: userSubscription.card.address_country,
          shortCode: this.getCountryShortCode(
            userSubscription.card.address_country,
          ),
        },
        state: {
          name: userSubscription.card.address_state,
          shortCode: '',
        },
        zip: userSubscription.card.address_zip,
      });
    }
  };

  enableIosChangePaymentDetails = () => {
    this.setState(initialState);
    history.push('/app/account-settings');
  };

  renderCardDetails = () => {
    const userSubscription = this.props.userSubscription;
    const action = this.props.action;

    if (action === 'UPGRADE') {
      return (
        <div className="card-details-container">
          {this.renderEditPaymentDetailsOptions(false)}
        </div>
      );
    }

    if (
      userSubscription &&
      userSubscription.card &&
      userSubscription.card.brand
    ) {
      return (
        <div className="card-details-container">
          {!this.state.isEditingPaymentDetails && userSubscription.card && (
            <div className="info-block">
              <div className="card-logo">
                {this.getPaymentMethodImage(userSubscription.card)}
              </div>
              <div className="card-data">
                <div className="last-four">
                  {this.getBrandAndLastFour(userSubscription.card)}
                </div>
                <div className="expiration-date">
                  {this.getCardExpirationDate(userSubscription.card)}
                </div>
              </div>
            </div>
          )}

          {!this.state.isEditingPaymentDetails && (
            <button
              className="btn btn-outline-secondary change-payment-button rounded-lg"
              onClick={() => this.enableChangePaymentDetails(true)}
            >
              CHANGE PAYMENT DETAILS
            </button>
          )}
          {this.state.isEditingPaymentDetails &&
            this.renderEditPaymentDetailsOptions(true)}
        </div>
      );
    }
    return (
      <div className="card-details-container">
        {!this.state.isEditingPaymentDetails && (
          <div className="no-details-text">
            <p className="no-details-title">No card data available</p>
            <p className="no-details-description">
              Update your payment method first, before selecting a subscription.
            </p>
          </div>
        )}
        {!this.state.isEditingPaymentDetails && (
          <button
            className="btn btn-outline-secondary change-payment-button rounded-lg"
            onClick={() => this.enableChangePaymentDetails(true)}
          >
            CHANGE PAYMENT DETAILS
          </button>
        )}
        {this.state.isEditingPaymentDetails &&
          this.renderEditPaymentDetailsOptions(true)}
      </div>
    );
  };

  toggleModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
    }));
  };

  handleClose = () => {
    this.state.closeButton = false;
    this.toggleModal();
  };

  convertMillisecondsToDate = (milisegundos) => {
    const fecha = new Date(milisegundos);

    const mm = `0${fecha.getMonth() + 1}`.slice(-2); // Month
    const dd = `0${fecha.getDate()}`.slice(-2); // Day
    const yyyy = fecha.getFullYear(); // year

    return `${mm}/${dd}/${yyyy}`;
  };

  renderIosSubscriptionOnTheWeb = (
    selectedPlan,
    couponCheck,
    totalCharge,
    discount,
  ) => {
    const { userSubscription } = this.props;

    const { showModal } = this.state;
    const switchType = getIosToStripeSwitchType(
      userSubscription?.productId,
      selectedPlan,
    );
    let endDateSubscription = '';
    let scheduledCreateSubscription = false;
    if (
      userSubscription &&
      userSubscription.type === 'iOS' &&
      userSubscription.status === 'active'
    ) {
      endDateSubscription = this.convertMillisecondsToDate(
        userSubscription.endedDate,
      );
      scheduledCreateSubscription = switchType === 'scheduled';
    }

    const disabledButton = this.isDisabledButton('iosToStripe');

    const cardData = {
      address_line1: this.state.address,
      address_city: this.state.city,
      address_state: this.state.state.name,
      address_country: this.state.country.name,
      address_zip: this.state.zip,
      name: `${this.state.firstName.trim()} ${this.state.lastName.trim()}`.trim(),
    };
    return (
      <div className="edit-payment-details-container fade-in">
        <div className="big-title fade-in">Payment Details</div>
        <div className="payment-card-container ">
          <div className="title fade-in">Payment Card</div>
          {/* FIRST NAME */}
          <div className="input-container full-width">
            <div className="label fade-in">first name</div>
            <Input
              id="first-name"
              className="edit-payment-input fade-in"
              value={this.state.firstName}
              type="text"
              onChange={this.handleFirstNameChange}
            />
          </div>
          {/* LAST NAME */}
          <div className="input-container full-width">
            <div className="label fade-in">last name</div>
            <Input
              id="last-name"
              className="edit-payment-input fade-in"
              value={this.state.lastName}
              type="text"
              onChange={this.handleLastNameChange}
            />
          </div>
        </div>
        <div className="billing-address-container">
          <div className="title fade-in">Billing Address</div>

          {/* ADDRESS */}
          <div className="input-container full-width">
            <div className="label fade-in">address</div>
            <Input
              id="adress"
              className="edit-payment-input fade-in"
              value={this.state.address}
              type="text"
              onChange={this.handleAddressChange}
            />
          </div>

          {/* CITY */}
          <div className="input-container full-width">
            <div className="label fade-in">city</div>
            <Input
              id="city"
              className="edit-payment-input fade-in"
              value={this.state.city}
              type="text"
              onChange={this.handleCityChange}
            />
          </div>

          {/* COUNTRY */}
          <div className="input-container full-width">
            <div className="field">
              <div className="manage-subscription-selector">
                <div className="label fade-in">country</div>
                <CountryDropdown
                  blacklist={['CU', 'UA', 'IR', 'KP', 'SY']}
                  value={this.state.country.name}
                  onChange={(country) => this.handleCountryOptionClick(country)}
                  classes="manage-subscription-dropdown-toggle fade-in"
                />
              </div>
            </div>
          </div>

          {/* STATE */}
          <div className="input-container full-width">
            <div className="field">
              <div className="manage-subscription-selector">
                <div className="label fade-in">state</div>
                <RegionDropdown
                  country={this.state.country.name}
                  value={this.state.state.name}
                  onChange={(state) => this.handleStateOptionClick(state)}
                  classes=" manage-subscription-dropdown-toggle fade-in"
                  defaultOptionLabel="Select State"
                />
              </div>
            </div>
          </div>

          {/* CARD NUMBER */}
          <div className="input-container full-width">
            <div className="label fade-in">card number</div>

            <ElementCard
              dataCard={this.dataCard}
              cardData={cardData}
              errorMessage={this.errorMessage}
              onCardReady={this.handleCardReady}
              setLoadingStripeToken={(value) =>
                this.setState({ isLoadingTokenCard: value })
              }
            />
          </div>
          {this.state.errorMessage && (
            <div className="message-error">{this.state.errorMessage}</div>
          )}

          <div className="charges-details-container">
            <div className="input-container full-width">
              <div className="label fade-in">Coupon</div>
              <Input
                className="fade-in"
                value={this.state.couponCode}
                type="text"
                onChange={(e) =>
                  this.setState({
                    couponCode: e.target.value,
                    couponChanged: true,
                    error: null,
                  })
                }
                onBlur={() => this.checkCoupon()}
              />
            </div>

            <div className="input-container full-width">
              <div className="label fade-in">Subscription Plan</div>
              {/* SUBSCRIPTION PLAN */}
              <div className="selector-container ">
                <select
                  required
                  className="form-control"
                  value={this.state.selectedPlan.id}
                  onChange={(e) => {
                    this.onPlanChange(e);
                  }}
                >
                  <option value="" disabled>
                    Select Pricing Plan
                  </option>
                  {this.props.plans.map((plan) => {
                    const label = `${plan.product.name} - $${(
                      plan.amount / 100
                    ).toFixed(2)} ${
                      plan.interval === 'month'
                        ? plan.interval_count === 6
                          ? 'per 6 months'
                          : 'per month'
                        : 'per year'
                    } plus tax`;
                    return (
                      <option key={plan.id} value={plan.id}>
                        {label}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="details-table">
              {this.state.selectedPlan.interval && (
                <div>
                  <div className="gray-divider" />
                  <div className="charge-row">
                    <div className="charge-title">
                      {this.state.selectedPlan.interval === 'year'
                        ? 'Annual Charge'
                        : this.state.selectedPlan.interval_count === 1
                          ? 'Monthly Charge'
                          : 'Semi-Annual Charge'}
                    </div>
                    <div className="cost">
                      $
                      {selectedPlan.id !== ''
                        ? (selectedPlan.amount / 100).toFixed(2)
                        : '0.00'}
                    </div>
                  </div>
                </div>
              )}

              {couponCheck &&
                this.state.couponCode &&
                !this.state.couponChanged && (
                  <div>
                    <div className="gray-divider" />
                    <div className="charge-row">
                      <div className="charge-title">Coupon</div>
                      <span className="cost">{discount}</span>
                    </div>
                  </div>
                )}
              <div className="gray-divider" />
              <div className="charge-row">
                <div className="charge-title">
                  {switchType === 'scheduled' && endDateSubscription
                    ? 'Scheduled Charge'
                    : "Today's Cost"}
                </div>
                <div className="cost">
                  ${this.state.selectedPlan.id !== '' ? totalCharge : '0.00'} +
                  tax
                </div>
              </div>
            </div>
            <div className="disclaimer">
              By clicking "Submit" above, you authorize us to begin your
              Promotion Wingman subscription
              {switchType === 'scheduled' && endDateSubscription
                ? ` on ${endDateSubscription}, when your current Apple subscription expires,`
                : ','}{' '}
              and to charge to the payment method provided. Your subscription
              will auto-renew. You can cancel anytime by going to "Account" and
              clicking on "Cancel Subscription" or by contacting us at{' '}
              <a href="mailto:support@promotionwingman.com" className="mailto">
                support@promotionwingman.com
              </a>
            </div>
            <div className="charges-footer">
              <div className="terms-checkbox-container">
                <div
                  className={
                    this.state.terms ? 'radio-selected' : 'radio-empty'
                  }
                  onClick={this.toggleTerms}
                />
                <div className="checkbox-label">
                  I Agree to the{' '}
                  <a
                    className="terms-link"
                    href="https://kaplan.com/privacy-policy"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms and Privacy Policy
                  </a>
                </div>
              </div>
            </div>
            <div className="edit-payment-details-footer">
              <button
                className="btn pw-btn-red cancel-btn"
                onClick={() => this.enableIosChangePaymentDetails()}
              >
                Cancel
              </button>
              <button
                className="btn pw-btn-blue submit-btn"
                disabled={disabledButton}
                onClick={() => {
                  if (userSubscription) {
                    this.toggleModal();
                  } else {
                    this.iosSubscriptionPaymentDetails(
                      couponCheck,
                      scheduledCreateSubscription,
                      true,
                    );
                  }
                }}
              >
                {this.renderButtonTextIosToWeb()}
              </button>
            </div>

            {((this.props.subscriptionOperationMessage.type === 'error' &&
              this.props.subscriptionOperationMessage.text !== '') ||
              this.state.error) && (
              <div className="message-error">
                {this.state.error
                  ? this.state.error
                  : this.props.subscriptionOperationMessage.text}
              </div>
            )}
          </div>
        </div>
        <ModalBase
          isOpen={showModal}
          toggle={this.toggleModal}
          header={<>SUBSCRIPTION ALERT</>}
          body={
            <>
              {endDateSubscription && userSubscription.status === 'active' ? (
                switchType === 'immediate' ? (
                  <div>
                    Your new subscription will activate immediately. A prorated
                    discount will be applied to your first web subscription
                    charge based on your unused Apple subscription time. Be sure
                    to manually cancel the subscription on iOS to avoid an
                    automatic charge. If you are sure you have canceled the
                    account on iOS and would like to continue, please click
                    "Continue".
                  </div>
                ) : (
                  <div>
                    <div className="accountActiveContainer">
                      <span className="accountActive">
                        Your subscription expires
                      </span>
                      <span className="accountActiveDate">
                        {endDateSubscription}
                      </span>
                    </div>
                    {`Please note that if you create a web subscription, you will be charged from ${endDateSubscription}.
          Be sure to manually cancel the subscription on iOS to avoid an automatic charge.
          If you are sure you have canceled the account on iOS and would like to continue, please click "Continue".`}
                  </div>
                )
              ) : (
                <div>
                  To access a subscription on the website, you must have
                  canceled your iOS subscription. If you have already canceled
                  it, please press continue.
                </div>
              )}
            </>
          }
          footer={
            <>
              <button
                className="btn modal-base-btn secondary"
                onClick={this.handleClose}
              >
                Close
              </button>
              <button
                className="btn modal-base-btn primary"
                onClick={() =>
                  this.iosSubscriptionPaymentDetails(
                    couponCheck,
                    scheduledCreateSubscription,
                  )
                }
              >
                Continue
              </button>
            </>
          }
        />
      </div>
    );
  };

  renderButtonTextIosToWeb = () => {
    const isEditPaymentWaiting = this.props.subscriptionOperationWaiting;
    const isLoadingTokenCard = this.state.isLoadingTokenCard;

    if (isEditPaymentWaiting) {
      return <CircularLoading className="loading-gif-btn" />;
    }
    if (isLoadingTokenCard) {
      return (
        <>
          <span>Validating Card</span>
          <CircularLoading
            className="loading-gif-btn"
            height="24px"
            width="24px"
          />
        </>
      );
    }
    return 'Submit';
  };

  componentDidMount() {
    const action = this.props.action;
    const selectedPlan = this.state.selectedPlan.id;
    const userSubscription = this.props.userSubscription;

    if (selectedPlan) {
      if (
        (action === 'RENEW' || action === 'CHANGE') &&
        userSubscription.id !== undefined &&
        userSubscription.id !== null
      ) {
        if (userSubscription.id !== 0 && userSubscription.card) {
          if (
            userSubscription.card.address_state &&
            userSubscription.card.address_state !== '' &&
            userSubscription.card.address_country &&
            userSubscription.card.address_country !== '' &&
            userSubscription.card.address_zip &&
            userSubscription.card.address_zip !== ''
          ) {
            this.setState({
              country: {
                name: userSubscription.card.address_country,
                shortCode: this.getCountryShortCode(
                  userSubscription.card.address_country,
                ),
              },
              state: {
                name: userSubscription.card.address_state,
                shortCode: '',
              },
              zip: userSubscription.card.address_zip,
            });
          } else {
            this.setState({
              mustEditPaymentDetails: true,
            });
          }
        } else {
          this.setState({
            mustEditPaymentDetails: true,
          });
        }
      } else if (action === 'UPGRADE') {
        // UPGRADE LOGIC
      }
    }
  }

  componentDidUpdate() {
    const elements = this.stripe.elements();
    const cardNumberDiv = document.getElementById('card-number');
    const expirationDateDiv = document.getElementById('card-expiration');
    const cardCVCDiv = document.getElementById('card-cvc');
    const _this = this;

    // CARD NUMBER
    if (cardNumberDiv && !this.state.cardElementMounted) {
      const cardNumberElement = elements.create('cardNumber', {
        style,
        placeholder: 'Card Number',
      });
      cardNumberElement.mount('#card-number');
      this.cardNumber = cardNumberElement;
      this.setState({ cardElementMounted: true });
      _this.cardNumber.addEventListener('change', (event) => {
        if (event.error) {
          _this.setState({ cardNumber: '' });
        }
        if (event.complete) {
          _this.setState({ cardNumber: _this.cardNumber });
        }
      });
    }

    // CARD EXPIRATION
    if (expirationDateDiv && !this.state.expirationElementMounted) {
      const cardExpiryElement = elements.create('cardExpiry', { style });
      cardExpiryElement.mount('#card-expiration');
      this.cardExpiry = cardExpiryElement;
      this.setState({ expirationElementMounted: true });
      _this.cardExpiry.addEventListener('change', (event) => {
        if (event.error) {
          _this.setState({ cardExpiry: '' });
        }
        if (event.complete) {
          _this.setState({ cardExpiry: _this.cardExpiry });
        }
      });
    }

    // CARD CVC
    if (cardCVCDiv && !this.state.cvcElementMounted) {
      const cardCVCElement = elements.create('cardCvc', { style });
      cardCVCElement.mount('#card-cvc');
      this.cardCVC = cardCVCElement;
      this.setState({ cvcElementMounted: true });
      _this.cardCVC.addEventListener('change', (event) => {
        if (event.error) {
          _this.setState({ cardCVC: '' });
        }
        if (event.complete) {
          _this.setState({ cardCVC: _this.cardCVC });
        }
      });
    }
  }

  getPaymentMethodImage = (card) => {
    let image = null;
    switch (card.brand) {
      case 'Visa':
        image = visaImg;
        break;
      case 'American Express':
        image = americanExpressImg;
        break;
      case 'Diners Club':
        image = dinersClubImg;
        break;
      case 'Discover':
        image = discoverImg;
        break;
      case 'JCB':
        image = jcbImg;
        break;
      case 'MasterCard':
        image = mastercardImg;
        break;
      case 'UnionPay':
        image = unionPayImg;
        break;
      default:
        image = null;
        break;
    }

    if (card && card.brand && image) {
      return (
        <img className="card-image" src={image} alt="" height="45" width="78" />
      );
    }
  };

  getBrandAndLastFour = (card) => {
    if (card) {
      return `${card.brand} ****${card.last4}`;
    }
    return '';
  };

  getCardExpirationDate = (card) => {
    if (card) {
      return `Expires: ${card.exp_month}/${card.exp_year}`;
    }
    return '';
  };

  getActionTitle = (action) => {
    switch (action) {
      case ('RENEW', 'UPGRADE'):
        return 'Suscribe to ';
      case 'CHANGE':
        return 'Change Subscription to ';
      default:
        return 'Suscribe to ';
    }
  };

  toggleTerms = () => {
    this.setState({ terms: !this.state.terms });
  };

  validateData = async () => {
    if (
      this.props.contentByRef &&
      this.props.contentByRef?.references?.length === 0
    ) {
      const planSelected = this.props.plans.filter(
        (plan) => plan.id === this.state.selectedPlan.id,
      );
      if (
        !planSelected[0]?.product?.name?.includes(
          'Warfare & Qualifications Only',
        )
      ) {
        this.setState({ openModalNoReferences: true });
        return;
      }
    }

    // clear previous error messages
    this.hideMessage(this.props.setEditPaymentDetailsMessage);
    this.hideMessage(this.props.setSubscriptionOperationMessage);

    const { couponCheck } = this.props;
    if (couponCheck === 'Not Valid' && this.state.couponCode !== '') {
      this.setState({ error: 'Coupon not valid' });
      this.props.setEditPaymentDetailsMessage({
        type: 'error',
        text: 'Coupon not valid',
      });
    } else {
      this.setState({ error: null });
      if (this.props.action === 'RENEW') {
        if (this.state.mustEditPaymentDetails) {
          const newSubscription = {
            dutyState: this.props.user.dutyState,
            rank: this.props.user.rank,
            rate: this.props.user.rate.id,
            stripeToken: null,
            tax: Number(this.state.tax),
            planId: this.state.selectedPlan.id,
            couponCode:
              couponCheck &&
              (couponCheck.amountOff > 0 || couponCheck.percentageOff > 0)
                ? this.state.couponCode
                : null,
          };
          newSubscription.stripeToken = this.state.tokenCard;
          this.props.renewSubscription(newSubscription);
        } else {
          // AUTOMATIC TAXJAR CALL WITH EXISTING CARD DATA
          const newSubscription = {
            dutyState: this.props.user.dutyState,
            rank: this.props.user.rank,
            rate: this.props.user.rate.id,
            stripeToken: null,
            tax: Number(this.state.tax),
            planId: this.state.selectedPlan.id,
            couponCode:
              couponCheck &&
              (couponCheck.amountOff > 0 || couponCheck.percentageOff > 0)
                ? this.state.couponCode
                : null,
          };

          this.props.renewSubscription(newSubscription);
        }
      }
    }

    if (this.props.action === 'CHANGE') {
      this.props.changeSubscription(this.props.userSubscription.id, {
        plan: this.state.selectedPlan.id,
        autoRenew: true,
        prorated: true,
        tax: Number(this.state.tax),
      });
    }

    if (this.props.action === 'UPGRADE') {
      const newSubscription = {
        dutyState: this.props.user.dutyState,
        rank: this.props.user.rank,
        rate: this.props.user.rate.id,
        stripeToken: null,
        tax: Number(this.state.tax),
        planId: this.state.selectedPlan.id,
      };

      newSubscription.stripeToken = this.state.tokenCard;
    }
  };

  onPlanChange = (event) => {
    const selectedPlan = this.props.plans.find(
      (p) => p.id === event.target.value,
    );

    this.setState({
      selectedPlan,
      planChanged: true,
      couponChanged: false,
    });
    this.props.onPlanSelect?.(selectedPlan);

    if (this.state.couponCode) {
      this.props.checkCoupon(
        this.state.couponCode,
        event.target.value, // planId
        false, // isTrialUser
        this.props.user.id,
      );
    }
  };

  checkCoupon = (plan) => {
    const { selectedPlan, couponCode, couponChanged } = this.state;

    const planId = plan ? plan.id : selectedPlan.id;
    if (planId === '' || couponCode === '' || (!couponChanged && !plan)) return;

    this.props.checkCoupon(couponCode, planId, false, this.props.user.id);

    this.setState({ couponChanged: false });
  };

  renderChargesDetails = (
    action,
    selectedPlan,
    submitCondition,
    totalCharge,
    discount,
  ) => {
    const { couponCheck } = this.props;
    return (
      <div className="charges-details-container">
        <Row className="component-container mb-2">
          <Col lg={2}>
            <div>Coupon</div>
          </Col>
          <Col lg={10}>
            <Input
              className="fade-in"
              value={this.state.couponCode}
              type="text"
              onChange={(e) =>
                this.setState({
                  couponCode: e.target.value,
                  couponChanged: true,
                  error: null,
                })
              }
              onBlur={() => this.checkCoupon()}
            />
          </Col>
        </Row>
        <Row className="component-container">
          <Col lg={2}>
            <div>{this.getActionTitle(action)}</div>
          </Col>
          {/* SUBSCRIPTION PLAN */}
          <Col lg={10}>
            <div className="selector-container ">
              <select
                required
                className="form-control"
                value={this.state.selectedPlan.id}
                onChange={(e) => {
                  this.onPlanChange(e);
                }}
              >
                <option value="" disabled>
                  Select Pricing Plan
                </option>
                {this.props.plans.map((plan) => {
                  const label = `${plan.product.name} - $${(
                    plan.amount / 100
                  ).toFixed(2)} ${
                    plan.interval === 'month'
                      ? plan.interval_count === 6
                        ? 'per 6 months'
                        : 'per month'
                      : 'per year'
                  } plus tax`;
                  return (
                    <option key={plan.id} value={plan.id}>
                      {label}
                    </option>
                  );
                })}
              </select>
            </div>
          </Col>
        </Row>
        <div className="details-table">
          <AudioMessage showDivider />
          {this.state.selectedPlan.interval && (
            <div>
              <div className="gray-divider" />
              <div className="charge-row">
                <div className="charge-title">
                  {this.state.selectedPlan.interval === 'year'
                    ? 'Annual Charge'
                    : this.state.selectedPlan.interval_count === 1
                      ? 'Monthly Charge'
                      : 'Semi-Annual Charge'}
                </div>
                <div className="cost">
                  $
                  {selectedPlan.id !== ''
                    ? (selectedPlan.amount / 100).toFixed(2)
                    : '0.00'}
                </div>
              </div>
            </div>
          )}

          {couponCheck &&
            this.state.couponCode &&
            !this.state.couponChanged && (
              <div>
                <div className="gray-divider" />
                <div className="charge-row">
                  <div className="charge-title">Coupon</div>
                  <span className="cost">{discount}</span>
                </div>
              </div>
            )}

          <div className="gray-divider" />
          <div className="charge-row">
            <div className="charge-title">Today's Cost</div>
            <div className="cost">
              ${selectedPlan.id !== '' ? totalCharge : '0.00'} + tax
            </div>
          </div>
        </div>
        <div className="disclaimer">
          By clicking "Send payment", you authorize us to begin your Promotion
          Wingman subscription, and to charge to the payment method provided.
          Your subscription will auto-renew. You can cancel anytime by going to
          "Account" and clicking on "Cancel Subscription" or by contacting us at{' '}
          <a href="mailto:support@promotionwingman.com">
            support@promotionwingman.com
          </a>
        </div>
        <div className="charges-footer">
          <div className="terms-checkbox-container">
            <div
              className={this.state.terms ? 'radio-selected' : 'radio-empty'}
              onClick={this.toggleTerms}
            />
            <div className="checkbox-label">
              I Agree to the{' '}
              <a
                className="terms-link"
                href="https://kaplan.com/privacy-policy"
                target="_blank"
                rel="noreferrer"
              >
                Terms and Privacy Policy
              </a>
            </div>
          </div>
          <button
            className="btn btn-primary submit-btn"
            disabled={
              !submitCondition || this.props.subscriptionOperationWaiting
            }
            onClick={this.validateData}
          >
            {this.props.subscriptionOperationWaiting ? (
              <CircularLoading className="loading-gif-btn" />
            ) : this.props.userSubscription &&
              this.props.userSubscription.status === 'past_due' ? (
              'RETRY PAYMENT'
            ) : (
              'SEND PAYMENT'
            )}
          </button>
        </div>
        {((this.props.subscriptionOperationMessage.type === 'error' &&
          this.props.subscriptionOperationMessage.text !== '') ||
          this.state.error) && (
          <div className="message-error">
            {this.state.error
              ? this.state.error
              : this.props.subscriptionOperationMessage.text}
          </div>
        )}
      </div>
    );
  };

  handleStateOptionClick = (stateName) => {
    this.setState({
      state: {
        name: stateName,
        shortCode: '',
      },
      zip: '',
    });
    this.props.setEditPaymentDetailsMessage({ type: 'error', text: '' });
  };

  handleCountryOptionClick = (countryName) => {
    this.setState({
      country: {
        name: countryName,
        shortCode: this.getCountryShortCode(countryName),
      },
      state: { name: '', shortCode: '' },
      zip: '',
    });
    this.props.setEditPaymentDetailsMessage({ type: 'error', text: '' });
  };

  handleFirstNameChange = (e) => {
    this.setState({ firstName: e.target.value });
  };

  handleLastNameChange = (e) => {
    this.setState({ lastName: e.target.value });
  };

  handleAddressChange = (e) => {
    this.setState({ address: e.target.value });
  };

  handleCityChange = (e) => {
    this.setState({ city: e.target.value });
  };

  handleZipChange = (e, edit) => {
    this.setState({ zip: e.target.value }, () => {
      if (this.state.zip.length >= 5 && !edit) {
        this.validateZip();
      }
    });
  };

  validateZip = async () => {
    this.props.setEditPaymentDetailsMessage({ type: 'error', text: '' });

    this.setState({
      taxJarReady: true,
    });
  };

  editPaymentDetails = async () => {
    const cardData = {
      address_line1: this.state.address,
      address_city: this.state.city,
      address_state: this.state.state.name,
      address_country: this.state.country.shortCode,
      address_zip: this.state.zip,
      name: `${this.state.firstName.trim()} ${this.state.lastName.trim()}`.trim(),
    };
    this.props.editPaymentDetails(this.props.userSubscription.id, {
      isEditPaymentDetails: true,
      stripeToken: this.state.tokenCard,
      cardData,
    });
  };

  iosSubscriptionPaymentDetails = (
    couponCheck,
    scheduledCreateSubscription,
    notSubscription,
  ) => {
    if (!notSubscription) {
      this.toggleModal();
    }

    this.setState({ isSubmittingIosToStripe: true });

    const newSubscription = {
      userId: this.props.user.id,
      planId: this.state.selectedPlan.id,
      couponCode:
        couponCheck &&
        (couponCheck.amountOff > 0 || couponCheck.percentageOff > 0)
          ? this.state.couponCode
          : null,
      country: this.state.country,
      address: this.state.address,
      state: this.state.state,
      zip: this.state.zip,
      stripeToken: this.state.tokenCard,
      scheduledCreateSubscription,
    };
    this.props.switchSubscriptionToStripe(newSubscription);
  };

  dataCard = (value) => {
    if (value) {
      // clear previous request error message
      this.hideMessage(this.props.setEditPaymentDetailsMessage);
      this.hideMessage(this.props.setSubscriptionOperationMessage);

      this.setState({
        tokenCard: value.tokenCard,
        zip: value.zip,
      });
    }
  };

  errorMessage = (value) => {
    this.setState({ errorMessage: value });
  };

  renderEditPaymentDetailsOptions = (edit) => {
    const disabledButton = this.isDisabledButton('manageMySubscription');

    const cardData = {
      address_line1: this.state.address,
      address_city: this.state.city,
      address_state: this.state.state.name,
      address_country: this.state.country.name,
      name: `${this.state.firstName.trim()} ${this.state.lastName.trim()}`.trim(),
    };

    return (
      <div className="edit-payment-details-container fade-in">
        <div className="big-title fade-in">Payment Details</div>
        <div className="payment-card-container ">
          <div className="title fade-in">Payment Card</div>
          {/* FIRST NAME */}
          <div className="input-container full-width">
            <div className="label fade-in">first name</div>
            <Input
              id="first-name"
              className="edit-payment-input fade-in"
              value={this.state.firstName}
              type="text"
              onChange={this.handleFirstNameChange}
            />
          </div>
          {/* LAST NAME */}
          <div className="input-container full-width">
            <div className="label fade-in">last name</div>
            <Input
              id="last-name"
              className="edit-payment-input fade-in"
              value={this.state.lastName}
              type="text"
              onChange={this.handleLastNameChange}
            />
          </div>
        </div>
        <div className="billing-address-container">
          <div className="title fade-in">Billing Address</div>
          {/* ADDRESS */}
          <div className="input-container full-width">
            <div className="label fade-in">address</div>
            <Input
              id="adress"
              className="edit-payment-input fade-in"
              value={this.state.address}
              type="text"
              onChange={this.handleAddressChange}
            />
          </div>
          {/* CITY */}
          <div className="input-container full-width">
            <div className="label fade-in">city</div>
            <Input
              id="city"
              className="edit-payment-input fade-in"
              value={this.state.city}
              type="text"
              onChange={this.handleCityChange}
            />
          </div>

          {/* COUNTRY */}
          <div className="input-container full-width">
            <div className="field">
              <div className="manage-subscription-selector">
                <div className="label fade-in">country</div>
                <CountryDropdown
                  blacklist={['CU', 'UA', 'IR', 'KP', 'SY']}
                  value={this.state.country.name}
                  onChange={(country) => this.handleCountryOptionClick(country)}
                  classes="manage-subscription-dropdown-toggle fade-in"
                />
              </div>
            </div>
          </div>

          {/* STATE */}
          <div className="input-container full-width">
            <div className="field">
              <div className="manage-subscription-selector">
                <div className="label fade-in">state</div>
                <RegionDropdown
                  country={this.state.country.name}
                  value={this.state.state.name}
                  onChange={(state) => this.handleStateOptionClick(state)}
                  classes=" manage-subscription-dropdown-toggle fade-in"
                  defaultOptionLabel="Select State"
                />
              </div>
            </div>
          </div>

          {/* CARD NUMBER */}
          <div className="input-container full-width">
            <div className="label fade-in">card number</div>

            <ElementCard
              dataCard={this.dataCard}
              cardData={cardData}
              errorMessage={this.errorMessage}
              onCardReady={this.handleCardReady}
              setLoadingStripeToken={(value) =>
                this.setState({ isLoadingTokenCard: value })
              }
            />
          </div>
          {this.state.errorMessage && (
            <div className="message-error">{this.state.errorMessage}</div>
          )}
        </div>
        {edit && (
          <div className="edit-payment-details-footer">
            <button
              className="btn pw-btn-red cancel-btn"
              onClick={() => this.enableChangePaymentDetails(false)}
            >
              Cancel
            </button>
            <button
              className="btn pw-btn-blue submit-btn"
              disabled={disabledButton}
              onClick={this.editPaymentDetails}
            >
              {this.renderButtonEditPaymentText()}
            </button>
          </div>
        )}
        {this.props.editPaymentDetailsMessage.text !== '' &&
          this.props.editPaymentDetailsMessage.type === 'error' && (
            <div className="subscription-message message-error">
              {this.props.editPaymentDetailsMessage.text}
            </div>
          )}
      </div>
    );
  };

  renderButtonEditPaymentText = () => {
    const isEditPaymentDetailsWaiting = this.props.editPaymentDetailsWaiting;
    const isLoadingTokenCard = this.state.isLoadingTokenCard;

    if (isEditPaymentDetailsWaiting) {
      return <CircularLoading className="loading-gif-btn" />;
    }
    if (isLoadingTokenCard) {
      return (
        <>
          <span>Validating Card</span>
          <CircularLoading
            className="loading-gif-btn"
            height="24px"
            width="24px"
          />
        </>
      );
    }
    return 'Submit';
  };

  renderRevertCancellationView = (userSubscription) => (
    <div className="revert-cancellation-container">
      <div className="revert-summary">
        Your account has been canceled. Your account services will stop on{' '}
        <strong>{userSubscription.next_bill_date}</strong>, at the end of this
        billing term. You'll have access to your subscription services and
        features until then.
      </div>
      <button
        className="btn btn-outline-secondary rounded-lg revert-button"
        onClick={this.props.revertCancellation}
      >
        {this.props.revertCancellationWaiting ? (
          <CircularLoading className="loading-gif-btn" />
        ) : (
          'REVERT CANCELLATION'
        )}
      </button>
      {this.props.revertCancellationMessage &&
        this.props.revertCancellationMessage.text != '' &&
        this.props.revertCancellationMessage.type === 'error' && (
          <div className="error-message">
            {this.props.revertCancellationMessage.text}
          </div>
        )}
    </div>
  );

  handleSubmit = () => {
    this.props.activateSubscription();
    this.setState({ activationSent: true });
  };

  getCountryShortCode = (countryName) => {
    const normalizedCountryName = countryName
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '');
    const country = countryCodes.find((c) => c.name === normalizedCountryName);
    return country?.code;
  };

  isDisabledButton = (view) => {
    let value =
      this.state.address === '' ||
      this.state.city === '' ||
      this.state.firstName === '' ||
      this.state.lastName === '' ||
      this.state.country.name === '' ||
      this.state.country.shortCode === '' ||
      this.state.state.name === '' ||
      this.state.tokenCard === '' ||
      this.state.isLoadingTokenCard ||
      this.state.errorMessage !== '';

    if (!value) {
      if (view === 'iosToStripe') {
        value =
          !this.state.terms ||
          this.state.selectedPlan.id === '' ||
          this.state.isSubmittingIosToStripe;
      } else if (view === 'manageMySubscription') {
        value = this.props.editPaymentDetailsWaiting;
      }
    }

    return value;
  };

  render() {
    const action = this.props.action;
    const userSubscription = this.props.userSubscription;
    const selectedPlan = this.state.selectedPlan;

    let submitCondition = null;

    if (action === 'RENEW' || action === 'CHANGE') {
      if (this.state.mustEditPaymentDetails) {
        submitCondition =
          this.state.terms &&
          this.state.address !== '' &&
          this.state.city !== '' &&
          this.state.firstName !== '' &&
          this.state.lastName !== '' &&
          this.state.country.name !== '' &&
          this.state.state.name !== '' &&
          this.state.cardNumber !== '' &&
          this.state.cardCVC !== '' &&
          this.state.cardExpiry !== '' &&
          this.state.selectedPlan.id !== '' &&
          this.state.zip !== '';
      } else {
        submitCondition = this.state.selectedPlan.id !== '' && this.state.terms;
      }
    }

    if (action === 'WEB') {
      submitCondition =
        (this.state.terms && this.state.address !== '') ||
        this.state.city !== '' ||
        this.state.firstName !== '' ||
        this.state.lastName !== '' ||
        this.state.country.name !== '' ||
        this.state.state.name !== '' ||
        this.state.errorMessage === '' ||
        this.state.selectedPlan.id !== '';
    }

    if (action === 'UPGRADE') {
      submitCondition =
        this.state.terms &&
        this.state.address !== '' &&
        this.state.city !== '' &&
        this.state.firstName !== '' &&
        this.state.lastName !== '' &&
        this.state.country.name !== '' &&
        this.state.state.name !== '' &&
        this.state.cardNumber !== '' &&
        this.state.cardCVC !== '' &&
        this.state.cardExpiry !== '' &&
        this.state.selectedPlan.id !== '' &&
        this.state.zip !== '';
    }

    const { couponCheck } = this.props;
    const { couponCode } = this.state;

    let totalCharge = selectedPlan.amount
      ? (selectedPlan.amount / 100).toFixed(2)
      : '';
    let discount = '';
    if (couponCheck.name === couponCode) {
      if (couponCheck.amountOff > 0)
        totalCharge = (totalCharge - couponCheck.amountOff).toFixed(2);
      else if (couponCheck.percentageOff > 0)
        totalCharge = (
          (totalCharge * (100 - couponCheck.percentageOff)) /
          100
        ).toFixed(2);
    }

    if (couponCheck === 'Not Valid' || couponCheck.name !== couponCode) {
      discount = 'Not Valid';
    } else if (couponCheck) {
      discount =
        couponCheck.amountOff > 0
          ? `$${couponCheck.amountOff.toFixed(2)} off!`
          : couponCheck.percentageOff > 0
            ? `${couponCheck.percentageOff}% off!`
            : 'Not Valid'
              ? couponCheck.name === couponCode
              : 'Not Valid';
    }

    const isRenewChangeUpgrade =
      action === 'RENEW' || action === 'CHANGE' || action === 'UPGRADE';
    const hasCardAttached = !!userSubscription?.card?.brand;

    return (
      <>
        <div className="billing-information">
          {action !== 'WEB' && (
            <div className="white-block">{this.renderCardDetails()}</div>
          )}
          {isRenewChangeUpgrade && hasCardAttached && (
            <div className="white-block charges-detail">
              {this.renderChargesDetails(
                action,
                selectedPlan,
                submitCondition,
                totalCharge,
                discount,
              )}
            </div>
          )}
          {action === 'WEB' && (
            <div className="white-block">
              {this.renderIosSubscriptionOnTheWeb(
                selectedPlan,
                couponCheck,
                totalCharge,
                discount,
              )}
            </div>
          )}
          {action === 'REVERT-CANCELLATION' && (
            <div className="white-block charges-detail">
              {this.renderRevertCancellationView(userSubscription)}
            </div>
          )}
        </div>
        {userSubscription && userSubscription.status === 'trialing' ? (
          <>
            <div className="primary-title mt-4">Activate Subscription</div>
            <div className="billing-information">
              <div className="white-block">
                If you switch now from a trialing account your trial period ends
                TODAY and you will be charged immediately.
                <Button
                  className="btn-activate-subscription mt-3"
                  size="xs"
                  block
                  onClick={() => this.handleSubmit()}
                >
                  {this.props.subscriptionActivationWaiting ? (
                    <CircularLoading className="loading-gif-btn" />
                  ) : (
                    'activate subscription'
                  )}
                </Button>
                {this.state.activationSent &&
                  this.props.subscriptionActivationMessage &&
                  this.props.subscriptionActivationMessage.type === 'error' && (
                    <div className="message-error">
                      {this.props.subscriptionActivationMessage.text}
                    </div>
                  )}
              </div>
            </div>
          </>
        ) : null}
        <ModalNoReferences
          isOpen={this.state.openModalNoReferences}
          isClose={() => this.setState({ openModalNoReferences: false })}
          user={this.props.user}
        />
      </>
    );
  }
}

export default BillingInformation;
